import { useEffect, useState } from 'react';
import { SectionWrapper } from '../../../../components/ui/SectionWrapper';
import { useLanguage } from '../../../../context/LanguageContext';
import { Certification } from '../../../../models/certification.interface';
import { certificationsService } from '../../../../services/certifications.service';

export function CertificationsSection() {
    const { t } = useLanguage();
    const [certifications, setCertifications] = useState<Certification[]>([]);

    useEffect(() => {
        setCertifications(certificationsService.getCertifications());
    }, []);

    return (
        <SectionWrapper id="certifications" title={t('section.certifications')}>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {certifications.map(cert => (
                    <div key={cert.id} className="flex items-start gap-4 bg-white dark:bg-slate-800 rounded-2xl p-5 shadow-sm ring-1 ring-slate-900/5 dark:ring-slate-700/50">
                        <div className="shrink-0 w-10 h-10 rounded-full bg-blue-100 dark:bg-blue-900/30 flex items-center justify-center">
                            <i className="bi bi-patch-check-fill text-blue-600 dark:text-blue-400" />
                        </div>
                        <div>
                            <h3 className="font-semibold text-slate-900 dark:text-white text-sm">
                                {cert.name}
                            </h3>
                            <p className="text-sm text-slate-500 dark:text-slate-400 mt-0.5">
                                {cert.issuer} &middot; {cert.year}
                            </p>
                        </div>
                    </div>
                ))}
            </div>
        </SectionWrapper>
    );
}
